import styled from '@emotion/styled';
import { useState } from 'react';
import { useNavigation } from '../../hooks/useNavigation';
import { deleteTokens } from '../../utils/util';
import ManagementLoginModal from './ManagementLoginModal';
import { GearIcon } from '../icons/Icons';

const Setting = () => {
  const [openManagementLoginModal, setOpenManagementLoginModal] = useState(false);
  const [openSetting, setOpenSetting] = useState(false);
  const { navigateToAdmin } = useNavigation();

  const handleGearClick = () => {
    if (openSetting) {
      setOpenSetting(false);
    } else {
      setOpenManagementLoginModal(true);
    }
  };

  const handleModalClose = () => {
    setOpenManagementLoginModal(false);
  };

  const handleManagementLoginSuccess = () => {
    handleModalClose();
    setOpenSetting(true);
  };

  return (
    <>
      <StyledGear onClick={handleGearClick} />
      {openSetting && (
        <StyledSetting>
          <div style={{ color: '#0066FF' }} onClick={navigateToAdmin}>
            관리자 페이지
          </div>
          <div
            style={{ color: '#FF0000' }}
            onClick={() => {
              deleteTokens();
              window.location.href = '/otp';
            }}
          >
            로그아웃
          </div>
        </StyledSetting>
      )}
      {openManagementLoginModal && (
        <ManagementLoginModal onClose={handleModalClose} onSuccess={handleManagementLoginSuccess} />
      )}
    </>
  );
};

export default Setting;

const StyledSetting = styled.div`
  position: absolute;
  bottom: 68px;
  left: 20px;
  width: 160px;
  height: 128px;
  border-radius: 12px;
  background-color: #fff;

  > div {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 64px;
    cursor: pointer;
    ${({ theme }) => theme.typography.SEMI_BOLD_24};
    border-bottom: solid 1px #00000080;
  }
`;

const StyledGear = styled(GearIcon)`
  position: absolute;
  bottom: 20px;
  left: 20px;
  cursor: pointer;
  color: ${({ theme }) => theme.color[3]};
`;
